import { Component, ViewChild, TemplateRef, ElementRef, OnInit } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { Router } from '@angular/router';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { messageService } from 'src/app/message.service';
import { qmsService } from '../qms.service';
import { SuccessSnackbarComponent } from 'src/app/support/success-snackbar/success-snackbar.component';
import { PaginationService } from 'src/app/PaginationService';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { DynamicAuditTrailComponent } from 'src/app/support/dynamic-audit-trail/dynamic-audit-trail.component';
import { ExcelPdfComponent } from 'src/app/support/excel-pdf/excel-pdf.component';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/core';
import { GridReorderComponent } from 'src/app/grid-reorder/grid-reorder.component';
import { concatMap, from, of, tap } from 'rxjs';
import { EditorComponent } from 'src/app/editor/editor.component';


export interface PopupData {
  title: string;
}

@Component({
  selector: 'app-risk-scale',
  templateUrl: './risk-scale.component.html',
  styleUrls: ['./risk-scale.component.scss'],
})

export class RiskScaleComponent implements OnInit {

  isProcessing = true;
  riskScaleData: any = {};

  auditTrail: any = {};
  visibleAuditTrail: boolean = false;

  applicableGroupsDropdown: any = [];
  dropdownForApplicableGroups: any = [];
  selectedApplicableGroups: any = [];

  moduleDropdown: any = [];
  dropdownForModule: any = [];

  constructor(public dialog: MatDialog, private readonly appService: AppService, public router: Router,
    private readonly snackBar: MatSnackBar, public message: messageService, private readonly elem: ElementRef,
    public qmsService: qmsService, public paginationService: PaginationService) {
  }

  ngOnInit() {
    const item = { valueExp: this.qmsService.selectedRiskModule, displayExp: this.qmsService.selectedRiskModule }

    this.dropdownForModule = JSON.parse(sessionStorage.getItem('dropDownForModules') ?? '{}');
    this.selectBoxForModule();

    this.appService.getQmsGroupsByModule(item.valueExp).subscribe((moduleData: any) => {
      this.dropdownForApplicableGroups = moduleData;
      this.selectBoxForApplicableGroups();
      this.isProcessing = false;
    })

    this.getCall();
  }

  htmlContent: any;
  @ViewChild(EditorComponent) editorComponent!: EditorComponent;
  getClobData(list: any, colunName: any, popupColumnName: any) {
    this.isProcessing = true;
    let docObj = {

      primeIdentifier: list.PRIM_IDENTIFIER,
      tableView: list.tablevwname,
      columnName: colunName
    }
    this.htmlContent = "";
    console.log(this.columnLists);
    this.appService.getClobToViewAudit(docObj).subscribe({
      next: (Response: any) => {
        this.htmlContent = Response.result;
        this.editorComponent.openEditor(this.htmlContent, popupColumnName);
      }, error: (error) => {
        throw error;
      }
    })
    this.isProcessing = false;

  }

  selectBoxForModule() {
    this.moduleDropdown = [];
    this.moduleDropdown = this.dropdownForModule?.filter((item: any) => item.codelistName != 'Documents' && item.codelistName != 'Trainings').map((item: any) => ({
      valueExp: item.codelistCode,
      displayExp: item.codelistName
    })) || []
  }

  validateNoFields(event: KeyboardEvent) {
    const forbiddenKeys = ['E', 'e', '-', '*', '+'];
    if (forbiddenKeys.includes(event.key)) {
      event.preventDefault();
    }
  }

  handleDropDownValidation(fieldId: string, selectedItems: any[] | string) {
    const field = document.getElementById(fieldId) as HTMLInputElement;
    const isMultiSelectValidation = (fieldId === 'group-validation');
    const shouldBeRed = isMultiSelectValidation ? !selectedItems.length : !selectedItems;

    field && (field.style.color = shouldBeRed ? 'red' : '#005c8a');
    !field && console.error('Unable to find the element. [handleDropDownValidation()] Id → ', fieldId);
  }

  onNgModelChange(items: any, fieldId: string) {
    const field = document.getElementById(fieldId) as HTMLInputElement;
    field.style.color = items ? '#005c8a' : 'red';
  }

  fieldValidation(elementIds: string[]) {
    elementIds.forEach((elementId) => {
      const element = document.getElementById(elementId) as HTMLInputElement;
      element.style.color = 'red';
    });
  }

  focusSearch(value: any) {
    setTimeout(() => { let searchBox = document.getElementById(value); searchBox?.focus(); }, 0)
  }

  selectBoxForApplicableGroups() {
    this.applicableGroupsDropdown = [];
    this.applicableGroupsDropdown = this.dropdownForApplicableGroups?.map((item: any) => ({
      valueExp: item.groupId,
      displayExp: item.groupName
    })).sort((m: { displayExp: string }, n: { displayExp: string }) => m?.displayExp?.trim()?.localeCompare(n?.displayExp?.trim())) || []
  }

  @ViewChild('applicableGroup') applicableGroup: MatSelect;
  isApplicableGroupsSelected = false;

  toggleAllSelection(value: any) {
    if (value == 'applicableGroup') {
      if (this.isApplicableGroupsSelected) {
        this.selectedApplicableGroups = this.applicableGroupsDropdown?.map((group: any) => group.valueExp) || [];
      } else {
        this.applicableGroup.options.forEach((item: MatOption) => item.deselect());
        this.selectedApplicableGroups = [];
      }
      setTimeout(() => {
        this.handleDropDownValidation('group-validation', this.selectedApplicableGroups)
      })
    }
  }

  applicableGroupsSearchText: any
  onApplicableGroupSelect(event: any, item: any) {
    if (event.isUserInput) {
      setTimeout(() => {
        this.isApplicableGroupsSelected = this.applicableGroupsDropdown.length == this.selectedApplicableGroups.length;
        this.handleDropDownValidation('group-validation', this.selectedApplicableGroups)
      })
    }
  }

  popupDataTitle: PopupData = {
    title: ''
  };

  popupTitle: string | null = 'title';
  @ViewChild('addAndEditPopup', { static: true }) addAndEditPopup: TemplateRef<any>;
  visibleAddAndEditPopup: MatDialogRef<TemplateRef<any>>;
  @ViewChild('deletePopup', { static: true }) deletePopup: TemplateRef<any>;
  visibleDeletePopup: MatDialogRef<TemplateRef<any>>;

  addAndEditPopupConfig = {
    width: '75%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '60px' },
  };

  deletePopupConfig = {
    width: '600px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: false,
    disableClose: true,
    position: { top: '10px' },
  };

  multiSelectDropdownSetting: IDropdownSettings = {
    idField: 'valueExp',
    textField: 'displayExp',
    enableCheckAll: true,
    allowSearchFilter: true,
    singleSelection: false,
    itemsShowLimit: 2,
  };

  visibleAddButton: boolean;
  visibleEditButton: boolean;
  operationFlag: any;

  openAddPopup() {
    this.visibleAddButton = true;
    this.visibleEditButton = false;
    this.operationFlag = 'ADD';
    this.popupDataTitle.title = "Add Risk Scale";
    this.selectedUserCriteria = 'Create New';
    [
      this.riskScaleData.riskScaleFrom,
      this.riskScaleData.riskScaleTo,
      this.riskScaleData.riskStatus,
      this.riskScaleData.comments,
      this.selectedApplicableGroups
    ] = ["", "", "", "", []];
    this.visibleAddAndEditPopup = this.dialog.open(this.addAndEditPopup, this.addAndEditPopupConfig);
    this.isApplicableGroupsSelected = false;
    setTimeout(() => { this.isApplicableGroupsSelected = this.applicableGroupsDropdown.length == this.selectedApplicableGroups.length; })
  }

  editingRiskScaleId: any;
  openEditPopup(editingData: any) {
    this.isProcessing = true;
    this.visibleAddButton = false;
    this.visibleEditButton = true;
    this.isApplicableGroupsSelected = false;
    this.operationFlag = 'EDIT';
    this.popupDataTitle.title = "Edit Risk Scale";
    this.selectedUserCriteria = 'Update';
    this.visibleAddAndEditPopup = this.dialog.open(this.addAndEditPopup, this.addAndEditPopupConfig);
    this.editingRiskScaleId = editingData.RISK_SCALE_ID;
    this.appService.getRiskScaleByRiskScaleId(this.editingRiskScaleId).subscribe((riskData: any) => {
      if (riskData.applicableGroups) {
        this.selectedApplicableGroups = riskData.applicableGroups.split(',').map(Number);
        setTimeout(() => {
          this.isApplicableGroupsSelected = this.applicableGroupsDropdown.length == this.selectedApplicableGroups.length;
          riskData.applicableGroups.split(',').length == this.dropdownForApplicableGroups.length && this.applicableGroup.options.forEach((item: MatOption) => item.select());
        })
      }
      this.riskScaleData = riskData;
      this.isProcessing = false;
    })
  }

  deletingRiskScaleId: any;
  openDeletePopup(deletingData: any) {
    this.operationFlag = 'DELETE';
    this.popupDataTitle.title = "Delete Risk Scale";
    this.deletingRiskScaleId = deletingData.RISK_SCALE_ID;
    this.riskScaleData.deleteReason = "";
    this.visibleDeletePopup = this.dialog.open(this.deletePopup, this.deletePopupConfig);
  }

  addAndEditFunction(riskScaleData: any) {

    const validations = [
      { condition: !riskScaleData.riskScaleFrom, id: 'scale-from-validation' },
      { condition: !riskScaleData.riskScaleTo, id: 'scale-to-validation' },
      { condition: !riskScaleData.riskStatus, id: 'status-validation' },
      { condition: !this.selectedApplicableGroups.length, id: 'group-validation' }
    ]

    const invalidIds = validations.filter((validation) => validation.condition).map((validation) => validation.id);

    if (invalidIds.length > 0) {
      this.fieldValidation(invalidIds);
    } else {
      this.isProcessing = true;
      const data = {
        module: this.qmsService.selectedRiskModule ?? null,
        riskScaleFrom: riskScaleData.riskScaleFrom,
        riskScaleTo: riskScaleData.riskScaleTo,
        riskStatus: riskScaleData.riskStatus,
        comments: riskScaleData.comments,
        applicableGroups: this.selectedApplicableGroups?.map(String).join(',')
      }

      if (this.operationFlag == 'ADD') {
        this.appService.createRiskScale(data).subscribe({
          next: (Response: any) => {
            if (Response.resultType == "S") {
              this.ngOnInit();
              this.visibleAddAndEditPopup.close();
              this.showSnackBar(Response.result, Response.resultType);
            } else {
              this.isProcessing = false;
              this.showSnackBar(Response.result, Response.resultType);
            }
          },
          error: (error) => {
            this.isProcessing = false;
            throw error;
          }
        });
      } else {
        const modifiedData = {
          ...data,
          riskScaleId: this.editingRiskScaleId
        }
        this.appService.updateRiskScale(modifiedData).subscribe({
          next: (Response: any) => {
            if (Response.resultType == "S") {
              this.ngOnInit();
              this.visibleAddAndEditPopup.close();
              this.showSnackBar(Response.result, Response.resultType);
            } else {
              this.isProcessing = false;
              this.showSnackBar(Response.result, Response.resultType);
            }
          },
          error: (error) => {
            this.isProcessing = false;
            throw error;
          }
        });
      }
    }
  }

  cancelAddAndEditFunction() {
    if (this.qmsService.isCopyingRisk) { this.qmsService.isCopyingRisk = false; this.getCall(); }
    this.visibleAddAndEditPopup.close();
  }

  deleteFunction(riskScaleData: any) {
    if (this.riskScaleData.deleteReason) {
      this.isProcessing = true;
      const data = {
        riskScaleId: this.deletingRiskScaleId,
        deleteReason: riskScaleData.deleteReason
      }

      this.appService.deleteRiskScale(data).subscribe({
        next: (Response: any) => {
          if (Response.resultType == "S") {
            this.ngOnInit();
            this.visibleDeletePopup.close();
            this.showSnackBar(Response.result, Response.resultType);
          } else {
            this.isProcessing = false;
            this.showSnackBar(Response.result, Response.resultType);
          }
        },
        error: (error) => {
          this.isProcessing = false;
          throw error;
        }
      });
    } else {
      const field = document.getElementById('delete-reason-validation') as HTMLInputElement;
      field.style.color = 'red';
    }
  }

  cancelDeleteFunction() {
    this.visibleDeletePopup.close();
  }

  showSnackBar(message: string, type: string) {
    const sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
      duration: type === 'S' ? 5000 : undefined,
      data: {
        message,
        type: type === 'S' ? 'Success' : 'Error',
        buttonLabel: 'Ok',
        pageName: this.message.breadcrumbData.thirdLevel ? this.message.breadcrumbData.thirdLevel : this.message.breadcrumbData.secondLevel,
      },
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: type === 'S' ? 'Success' : 'Error',
    });

    sb.onAction().subscribe(() => {
      sb.dismiss();
    });
  }

  searchText: any;
  searchValue: any;
  _temp: any = {};
  columnLists: any = {};
  grid: any = [];
  gridTemp: any;
  makeStickyColumns: any;
  dataTypeList: any = [];
  visibleDataGrid: boolean = false;
  itemsPerPage = 5;
  currentPage = 1;
  totalPages = 0;
  maxSize = 3;
  collectionSize: number;
  perPage = 10;
  calculateTotalPages: number;
  showingResultsText = "Showing results";
  displayingClaimsText = "Displaying claims";
  rowText = "Rows";
  showingRowsText = "Showing rows";
  pager: any = {};
  pagedItems: any[];
  error = '';

  getCall() {
    this.isProcessing = true;
    setTimeout(() => {
      this.isProcessing = false;
    }, 3000);
    const data = {

      gridName: "RISK_SCALE",
    }
    this.appService.getDynamicGridHeaders(data).subscribe({
      next: (response: any) => {
        response.orderByClause = response.orderByClause ? response.orderByClause : "";
        this.makeStickyColumns = response.fixedFieldCnt;
        const data1: any = {

          gridName: "QMS_RISK_SCALE_VW",
          tableOrViewName: response.tableOrViewName ?? "",
          columnsList: response.columnsList ?? "",
          fieldLabelsList: response.fieldLabelsList ?? "",
          invisibleColumn: response.invisibleColumn ?? "",
          orderByClause: response.orderByClause ?? "",
          fieldSizeList: response.fieldSizeList ?? "",
          columnsListarray: [],
          fieldColumnarray: [],
          invisibleColumnarray: [],
          fieldSizeListArray: [],
          manualEntryDataFields: response.manualEntryDataFields,
          module: this.qmsService.isCopyingRisk ? this.selectedSourceModule ?? null : this.qmsService.selectedRiskModule ?? null,
          clobColumnlist: response.closblist || "",
          blobColumnlist: response.bloblist || ""
        }
        this.reportObj = { ...data1, ...data };
        this.auditTrail.secondary_obj = data1;
        this.appService.getDynamicGridData(data1).subscribe({
          next: (response1: any) => {
            this.grid = response1;
            this.visibleAuditTrail = false;
            data1.columnsListarray = data1.columnsList.split(",");
            data1.fieldColumnarray = data1.fieldLabelsList.split(",");
            data1.invisibleColumnarray = data1.invisibleColumn.split(",");
            data1.fieldSizeListArray = data1.fieldSizeList.split(",");
            this.columnLists.columnsListarray = data1.columnsListarray;
            this.columnLists.fieldLabelsList = data1.fieldLabelsList;
            this.columnLists.fieldColumnarray = [];
            for (let p = 0; p < data1.fieldColumnarray.length; p++) {
              this.columnLists.fieldColumnarray.push({
                "fieldColumnarray": data1.fieldColumnarray[p],
                "width": data1.fieldSizeListArray[p] + 'px'
              })
            }
            this.columnLists.invisibleColumnarray = data1.invisibleColumnarray;
            this.columnLists.fieldSizeListArray = [];
            for (const element of data1.fieldSizeListArray) {
              this.columnLists.fieldSizeListArray.push(element + 'px');
            }
            for (let y = 0; y < this.columnLists.columnsListarray.length; y++) {
              for (const element of this.columnLists.invisibleColumnarray) {
                if (this.columnLists.columnsListarray[y] == element) {
                  this.columnLists.columnsListarray.splice(y, 1);
                  this.columnLists.fieldColumnarray.splice(y, 1);
                  this.columnLists.fieldSizeListArray.splice(y, 1);
                }
              }
            }
            let tableData = {
              tablename: data1.tableOrViewName
            };
            this.columnLists.columnsListarray1 = [];
            this.appService.tableFieldsDataType(tableData).subscribe((response2: any) => {
              this.dataTypeList = response2;
              for (let m = 0; m < this.columnLists.columnsListarray.length; m++) {
                this.columnLists.columnsListarray1.push({});
                this.columnLists.columnsListarray1[m].columnsListarray = this.columnLists.columnsListarray[m];
                this.columnLists.columnsListarray1[m].dataType = "textbox";
                this.columnLists.columnsListarray1[m].width = this.columnLists.fieldSizeListArray;
                for (const element of this.dataTypeList) {
                  if (element.columnName == this.columnLists.columnsListarray[m]) {
                    this.columnLists.columnsListarray1[m].dataType = element.fieldType;
                  }
                }
              }
              for (const rowData of this.grid) {
                for (const element of this.dataTypeList) {
                  if (element.fieldType === 'CHECKBOX') {
                    rowData[element.columnName] = rowData[element.columnName] === 'Y';
                  }
                }
              }
              this.calculateTotalPages = this.collectionSize / this.perPage;
              this.pager.totalPages = undefined;
              this.setPage(1, 0);
            });
            this.message.gridList = this.grid;
            this.collectionSize = this.grid.length;
            this.totalPages = Math.ceil(this.grid.length / this.itemsPerPage);
            this.dynamicLabelCall();
            this.isProcessing = false;
          },
          error: (error) => {
            this.isProcessing = false;
            throw error;
          }
        });
        this.isProcessing = false;
      }, error: (error) => {
        this.isProcessing = false;
        throw error;
      }
    });
  }

  setPage(page: number, targetPage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }
    this.pager = this.paginationService.getPager(this.grid.length, page, this.perPage, targetPage);
    this.pagedItems = this.grid.slice(this.pager.startIndex, this.pager.endIndex + 1);
  }

  setPagedOrSearch(page: number, targetPage: number) {
    if (Number.isNaN(page)) {
      page = 1;
    }

    if (this.gridTemp.length > 0) {
      this.pager = this.paginationService.getPager(this.gridTemp.length, page, this.perPage, targetPage);
      this.pagedItems = this.gridTemp.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = [];
    }
  }

  paginationCall(value: number) {
    this.perPage = value;
    this.setPage(this.pager.currentPage, 0);
  }

  applyFilter3(column: string, event: Event): void {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.pagedItems = this.grid.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = this.grid.filter((item: any) =>
        item[column]?.toLowerCase().includes(filter)
      );
    }
  }


  searchValue2: any;
  applyFilter2(event: Event) {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.gridTemp = this.grid;
      this.pager = this.paginationService.getPager(this.gridTemp.length, 1, this.perPage, 0);
      this.pagedItems = this.gridTemp.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      if (this.grid == undefined) {
        return this.grid;
      }
      if (!this.grid.length) {
        return this.grid;
      }
      if (filter) {
        this.gridTemp = this.grid.filter(function (item: any) {
          return JSON.stringify(item).toLowerCase().includes(filter);
        });
      } else {
        this.gridTemp = this.grid.filter(function (item: any) {
          return JSON.stringify(item).toLowerCase();
        });
      }
      this.setPagedOrSearch(1, 0);
    }
  }

  sortedColumn: string = '';
  sortDirection: string = 'asc';
  sortColumn(column: string, list: any) {
    if (column === this.sortedColumn) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortedColumn = column;
      this.sortDirection = 'asc';
    }
    list.showsort = this.sortDirection;

    this.grid.sort((a: { [x: string]: any; }, b: { [x: string]: any; }) => {
      const key = column;
      const valueA = a[key];
      const valueB = b[key];

      if (valueA < valueB) {
        return this.sortDirection === 'asc' ? -1 : 1;
      } else if (valueA > valueB) {
        return this.sortDirection === 'asc' ? 1 : -1;
      } else {
        return 0;
      }
    });
    this.setPage(1, 0);
  }

  counts: any;
  cssFunction(ix: number) {
    let elements1 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-col1');
    let index1 = 1;
    let headerWidth = 0;
    elements1.forEach((header: any, key: any) => {
      for (let i = 1; i <= this.makeStickyColumns; i++) {
        if (index1 == i) {
          header.style.position = 'sticky';
          header.style.background = 'white';
          if (index1 > 1) {
            headerWidth += 200;
            header.style.left = headerWidth + 'px';
          } else {
            headerWidth = 60;
            header.style.left = headerWidth + 'px';
          }
        }
      }
      index1++;
    })

    let elements2 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-row1');
    let index2 = 1;
    let lengthOfColumns = this.columnLists.columnsListarray1.length;
    let colWidth = 0;
    let p = 1;
    elements2.forEach((column: any, key: any) => {
      for (let j = 1; j <= this.makeStickyColumns; j++) {
        if (index2 == j) {
          column.style.position = 'sticky';
          p = p + 1;
          column.style.background = 'white';

          if (index2 > 1) {
            colWidth += 200;
            let previousColumn = elements2[key - 1];
            console.log(previousColumn.style.width);
            column.style.left = colWidth + 'px';
          } else {
            colWidth = 60;
            column.style.left = colWidth + 'px';
          }
          column.addEventListener('click', this.onClick.bind(this));
        }
      }
      if (index2 == (lengthOfColumns - 1)) {
        index2 = 0;
      } else {
        index2++;
      }
    })
  }

  onClick(event: any) {

  }

  parentCheckBox: boolean = false;
  childCheckBox: boolean = false;
  dataGridParentCheckBoxChecked(e: any) {
    if (e.target.checked) {
      this.childCheckBox = true;
      for (const element of this.grid) {
        element.childCheckBox = true;
      }
    } else {
      this.childCheckBox = false;
      for (const element of this.grid) {
        element.childCheckBox = false;
      }
    }
  }

  previousIdx: any;
  dataGridChildCheckBoxChecked(e: any, list: any, idx: any) {
    if (e.target.checked) {
      if (this.previousIdx != undefined) {
        this.grid[this.previousIdx].childCheckBox = false;
      }
      list.childCheckBox = true;
      this.auditTrail.refNo = list.RISK_SCALE_ID;
    } else {
      list.childCheckBox = false;
    }
    this.visibleAuditTrail = this.grid.some((list: any) => list.childCheckBox);
    this.previousIdx = idx;
  }


  onParentChanged(e: any) {
    if (e.target.checked) {
      if (this.qmsService.isCopyingRisk) { this.copyingSettingsData = this.pagedItems.length == 10 ? this.grid : this.pagedItems; }
      for (const element of this.grid) {
        element.childCheckBox = true;
      }
    } else {
      if (this.qmsService.isCopyingRisk) { this.copyingSettingsData = [] }
      for (const element of this.grid) {
        element.childCheckBox = false;
      }
    }
  }

  onChildChanged(e: any, list: any, idx: any) {
    if (e.target.checked) {
      this.onChildChecked(list);
    } else {
      this.parentCheckBox = list.childCheckBox = false;
      this.qmsService.isCopyingRisk && this.onChildUnchecked(list);
    }
  }

  onChildChecked(checked: any) {
    if (!this.qmsService.isCopyingRisk) {
      this.grid.every((item: any) => { if (item.childCheckBox) { item.childCheckBox = false; } return true; })
      checked.childCheckBox = true;
    } else if (!this.copyingSettingsData?.some((copied: any) => copied.RISK_SCALE_ID === checked.RISK_SCALE_ID)) {
      this.copyingSettingsData.push(checked);
      if (this.grid.every((r: any) => r.childCheckBox)) { this.parentCheckBox = true; }
    }
  }

  onChildUnchecked(unchecked: any) {
    this.copyingSettingsData = this.copyingSettingsData?.filter(
      (copied: any) => copied.RISK_SCALE_ID !== unchecked.RISK_SCALE_ID
    );
  }

  refreshGridData() {
    this.isProcessing = true;
    this.getCall();
  }

  keyPressed: any
  handleKeyPress(event: KeyboardEvent) {
    this.keyPressed = event.key;
  }

  @ViewChild(DynamicAuditTrailComponent) dynamicAuditTrailComponent!: DynamicAuditTrailComponent;

  openAuditTrail(viewType: any, riskScale: any) {
    this.auditTrail.refNo = viewType == 'overAll' ? null : riskScale.RISK_SCALE_ID;
    this.auditTrail.gridName = 'RISK_SCALE';
    this.auditTrail.report_And_Popup_Name = 'Risk Scale Audit Trail';
    this.dynamicAuditTrailComponent.triggerTrail(riskScale);
  }

  @ViewChild(ExcelPdfComponent) excelPdfComponent!: ExcelPdfComponent;
  excelPdf: any = {};
  reportObj: any = {};

  openReport(reportType: string) {
    this.excelPdf.reportObj = this.reportObj;
    this.excelPdf.reportType = 'Dynamic';
    this.excelPdf.reportName = 'Risk Scale Report';
    this.excelPdf.dropDown = this.columnLists?.fieldColumnarray?.map((item: any) => item.fieldColumnarray);
    this.excelPdfComponent.openReportPopup(reportType);
  }

  @ViewChild(GridReorderComponent) gridReorderComponent!: GridReorderComponent;
  openReorder() {
    this.gridReorderComponent.reordercall(this.reportObj.gridName, this.reportObj.tableOrViewName, null, 0)
  }

  onChildValueEmitted() {
    this.getCall();
  };

  dynamicLabel: any = null;
  label: any = [];
  dynamicLabelCall() {
    this.isProcessing = true;
    const data = {
      tableName: this.reportObj.tableOrViewName,
      moduleName: null,
      gridName: this.reportObj.gridName,
      groupId: 0,
    };
    this.appService.getreorderGirdColumnList(data).subscribe({
      next: (data: any) => {
        this.label = data;
        this.dynamicLabel = this.label.reduce((acc: any, user: any) => {
          acc[`${user.columnName}`] = user.changedFieldName;
          return acc;
        }, {});
        this.isProcessing = false;
      }, error: (error: any) => {
        this.isProcessing = false;
        throw error;
      }
    });
  }

  selectedUserCriteria: any;
  searchCriteriaOptions: any = ['Create New', 'Copy'];
  copyingSettingsData: any = [];

  @ViewChild('copyResultPopup', { static: true }) copyResultPopup: TemplateRef<any>;
  visibleCopyResultPopup: MatDialogRef<TemplateRef<any>>;

  copyResultPopupConfig = {
    width: '75%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '60px' },
  };

  onSearchCriteriaChanged(criteria: any) {

    if (criteria == 'Create New') {
      [
        this.riskScaleData.riskScaleFrom,
        this.riskScaleData.riskScaleTo,
        this.riskScaleData.riskStatus,
        this.riskScaleData.comments,
        this.selectedApplicableGroups,
        this.qmsService.isCopyingRisk
      ] = ["", "", "", "", [], false];
    } else {
      [
        this.pagedItems,
        this.grid,
        this.copyingSettingsData,
        this.responses,
        this.selectedSourceModule,
        this.selectedTargetModule,
        this.selectedApplicableGroups,
        this.parentCheckBox,
        this.qmsService.isCopyingRisk
      ] = [[], [], [], [], null, null, null, false, true];
    }

    this.isApplicableGroupsSelected = false;
  }

  selectedSourceModule: any;
  selectedTargetModule: any;
  moduleSearchTxt: any;
  onSourceModuleSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (item) {
        this.isProcessing = true;
        this.appService.getQmsGroupsByModule(item.valueExp).subscribe((moduleData: any) => {
          this.dropdownForApplicableGroups = moduleData;
          this.selectBoxForApplicableGroups();
          this.isProcessing = false;
        })
        this.getCall();
      } else {
        this.isProcessing = false;
      }
    }
  }

  onTargetModuleSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (item) {
        this.isProcessing = true;
        this.appService.getQmsGroupsByModule(item.valueExp).subscribe((moduleData: any) => {
          this.dropdownForApplicableGroups = moduleData;
          this.selectBoxForApplicableGroups();
          this.isProcessing = false;
        })
      } else {
        this.dropdownForApplicableGroups = [];
        this.selectedApplicableGroups = null;
      }
    }
  }

  responses: any[] = []; /* To store the responses sequentially */

  copy() {
    this.isProcessing = true;
    from(this.copyingSettingsData) /* 'from' converts the array into an observable stream */
      .pipe(
        concatMap((scale: any, index: number) => { /* 'concatMap' ensures that the next API call does not start until the current one is complete */

          const risk = {
            module: this.selectedTargetModule ?? null,
            riskScaleFrom: scale.RISK_SCALE_FROM,
            riskScaleTo: scale.RISK_SCALE_TO,
            riskStatus: scale.RISK_STATUS,
            comments: scale.COMMENTS,
            applicableGroups: this.selectedApplicableGroups?.map(String).join(',')
          }

          /*  Call the API for the current setting */
          return this.appService.createRiskScale(risk).pipe(
            tap((Response: any) => { /* 'tap' is an operator used to perform side effects for debugging or performing actions without altering the data flowing through the observable stream */
              /* Store the response after the API call */
              this.responses[index] = { scale, response: Response, };
            }),
            /* Ensure the observable emits a value for next() */
            concatMap(() => of(scale))
            /* 'of(setting)' creates an observable that emits the current setting after the API call is complete.
               This observable is processed by the from pipeline and triggers the next handler for every iteration */
          );
        })
      )
      .subscribe({
        next: (item) => {
          console.log('Processed an item:', item); /* Logs the processed item where this next is triggered by of(setting) */
        },
        complete: () => {
          console.log('All API calls have been processed');
          console.log('Responses:', this.responses); /* Log the final responses array */
          this.isProcessing = false;
          this.visibleAddAndEditPopup.close();
          this.visibleCopyResultPopup = this.dialog.open(this.copyResultPopup, this.copyResultPopupConfig);
        },
        error: (error) => {
          this.isProcessing = false;
          console.error('Error occurred:', error);
        },
      });
  }

  cancelCopyResultPopup() {
    this.qmsService.isCopyingRisk = false;
    this.getCall();
    this.visibleCopyResultPopup.close();
  }

  public focusEmpty(): void {
    console.log();
  }
}
